import React from "react";
import PageHeader from "./PageHeader";
import HeaderSection from "./HeaderSection";
import PlatformAndVehicleSection from "./PlatformAndVehicleSection";
import IssuesPanel from "./IssuesPanel";
import GroupedTripsTable from "./GroupedTripsTable";
import { hasRideshareEarnings } from "./helpers";

// The week range comes in via URL from the payments platform (eye-icon
// navigation); there is no in-page date picker — change the week on the
// payments platform and re-click the eye icon.
const DriverDetail = ({ initial_data, week_range }) => {
  const data = initial_data || {};
  const range = week_range || { from: "", to: "" };
  const fullName = data.driver?.full_name || "Driver";

  return (
    <main className="min-h-screen bg-gray-50 text-gray-900 font-sans">
      <div className="max-w-[1440px] mx-auto p-6 space-y-6">
        <PageHeader fullName={fullName} range={range} />

        <HeaderSection data={data} />

        <PlatformAndVehicleSection data={data} />

        {hasRideshareEarnings(data.platform_breakdown) && (
          <IssuesPanel issues={data.issues || []} />
        )}

        <GroupedTripsTable groupedTrips={data.grouped_trips || []} />
      </div>
    </main>
  );
};

export default DriverDetail;
